import { useContext, useState } from "react";
import { FaTrashAlt, FaUndoAlt } from "react-icons/fa";
import { iTech } from "..";

import { TechContext } from "../../../contexts/TechContext";

import Item from "./style";

interface iTechItemProps {
  tech: iTech;
}

const TechItem = ({ tech }: iTechItemProps) => {
  const { techDelete } = useContext(TechContext);
  const [loadButton, setLoadButton] = useState(false);

  const deleteTech = async (id: string) => {
    techDelete(id, setLoadButton);
  };

  return (
    <Item id={tech.id}>
      <h3>{tech.title}</h3>
      <div>
        <span>{tech.status}</span>
        <button
          type="button"
          disabled={loadButton}
          onClick={() => deleteTech(tech.id)}
        >
          {!loadButton ? <FaTrashAlt /> : <FaUndoAlt />}
        </button>
      </div>
    </Item>
  );
};

export default TechItem;
